var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inner-click-component',[_c('h2',[_vm._v(_vm._s(_vm.paramTitle)+"：哈哈哈"+_vm._s(_vm.paramCount)+" ")])]),_vm._v(" "),_c('inner-click-component',{on:{"click":function($event){}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fb3c404","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SimpleClickEvent.vue
// module id = null
// module chunks = 